var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66675 40C6.66675 21.6 21.6001 6.66666 40.0001 6.66666C58.4001 6.66666 73.3334 21.6 73.3334 40C73.3334 58.4 58.4001 73.3333 40.0001 73.3333C21.6001 73.3333 6.66675 58.4 6.66675 40ZM19.0001 42.3333L30.9667 54.3C32.2667 55.6 34.4001 55.6 35.6667 54.3L60.9667 29C62.2667 27.7 62.2667 25.6 60.9667 24.3C59.6667 23 57.5667 23 56.2667 24.3L33.3334 47.2333L23.7001 37.6333C22.4001 36.3333 20.3001 36.3333 19.0001 37.6333C18.3759 38.2561 18.0251 39.1016 18.0251 39.9833C18.0251 40.865 18.3759 41.7106 19.0001 42.3333Z",
    fill: "#27AE60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/checkCircle.d1530df51588cbafada1ef1a958c5b73.svg";
export { ForwardRef as ReactComponent };